export enum MandateTypes {
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}
export enum MandateStatus {
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  ACTIVE = 'ACTIVE',
  FAILED = 'FAILED',
}

export default {
  MandateTypes,
  MandateStatus,
};
